import { z } from "zod";
import { paymentDetailsSchema, productDetailsSchema, } from "./core/index.js";
export const checkoutConfigSchema = z.object({
    /**
     * @inheritdoc PaymentDetails
     */
    paymentDetails: paymentDetailsSchema.transform((x) => x),
    /**
     * @inheritdoc ProductDetails
     */
    productDetails: productDetailsSchema.transform((x) => x),
    /**
     * The token list that contains Super Tokens and their underlying tokens.
     */
    tokenList: z.custom(),
});
const widgetPropsSchema = z.object({
    /**
     * @inheritdoc PaymentDetails
     */
    paymentDetails: paymentDetailsSchema,
    /**
     * @inheritdoc ProductDetails
     */
    productDetails: productDetailsSchema.optional(),
    /**
     * The token list that contains Super Tokens and their underlying tokens.
     */
    tokenList: z.custom().optional(),
    /**
     * The MUI theme object to style the widget. Learn more about it from the MUI documentation: https://mui.com/material-ui/customization/default-theme/
     */
    theme: z
        .custom()
        .optional(),
    /**
     * Whether the stepper UI component inside the widget is vertical or horizontal. Vertical is better supported.
     */
    stepper: z
        .custom()
        .optional(),
    /**
     * @inheritdoc WalletManager
     */
    walletManager: z.custom().optional(),
    /**
     * @inheritdoc EventListeners
     */
    eventListeners: z.custom().optional(),
    networkAssets: z.custom().optional(),
});
